import { render } from "./CallToActionNew.vue?vue&type=template&id=75fac8a3&scoped=true"
import script from "./CallToActionNew.vue?vue&type=script&lang=js"
export * from "./CallToActionNew.vue?vue&type=script&lang=js"

import "./CallToActionNew.vue?vue&type=style&index=0&id=75fac8a3&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75fac8a3"]])

export default __exports__